import apiService from './api';

export interface FAQ {
    id: string;
    question: string;
    answer: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export const faqsService = {
    async getAll(params: { is_active?: boolean, page?: number, limit?: number, search?: string } = {}) {
        const queryParams = new URLSearchParams();
        if (params.is_active !== undefined) queryParams.append('is_active', String(params.is_active));
        if (params.limit !== undefined) queryParams.append('limit', String(params.limit));
        if (params.page !== undefined) queryParams.append('page', String(params.page));
        if (params.search !== undefined && params.search.trim() !== '') queryParams.append('search', params.search);

        const queryString = queryParams.toString();
        const url = queryString ? `/api/faqs?${queryString}` : '/api/faqs';

        return apiService.get<{ data: FAQ[], total: number, page: number, totalPages: number }>(url);
    },

    async create(data: { question: string, answer: string, is_active?: boolean }) {
        return apiService.post<FAQ>('/api/faqs', data);
    },

    async update(id: string, data: { question?: string, answer?: string, is_active?: boolean }) {
        return apiService.put<FAQ>(`/api/faqs/${id}`, data);
    },

    async delete(id: string) {
        return apiService.delete<{ message: string }>(`/api/faqs/${id}`);
    },

    async sync() {
        return apiService.post<{ success: boolean; count: number }>('/api/faqs/sync', {});
    },

    async downloadTemplate() {
        const token = localStorage.getItem('authToken');
        const schoolCode = localStorage.getItem('schoolCode');
        const headers: HeadersInit = {
            'Authorization': `Bearer ${token}`
        };
        if (schoolCode) {
            headers['x-school-code'] = schoolCode;
        }

        const response = await fetch('/api/faqs/template', {
            headers
        });
        if (!response.ok) throw new Error('Failed to download template');
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'faq-import-template.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    },

    async importFaqs(file: File) {
        const formData = new FormData();
        formData.append('file', file);

        const token = localStorage.getItem('authToken');
        const schoolCode = localStorage.getItem('schoolCode');
        const headers: HeadersInit = {
            'Authorization': `Bearer ${token}`
        };
        if (schoolCode) {
            headers['x-school-code'] = schoolCode;
        }

        const response = await fetch('/api/faqs/import', {
            method: 'POST',
            headers,
            body: formData
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Import failed');
        return data as {
            success: boolean;
            message: string;
            totalRows: number;
            successfulImports: number;
            failedImports: number;
            errors: any[];
            successes: any[];
        };
    }
};
